import React from 'react';
import { Button } from './ui/button';
import { images } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-background">
        <img 
          src={images.hero} 
          alt="Stavební projekty" 
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="hero-content max-w-4xl">
          <h1 className="hero-title mb-8">
            POCTIVÁ ZEDNIČINA, NA KTERÉ MŮŽETE STAVĚT.
          </h1>
          <p className="body-large mb-6 max-w-2xl">
            Jsme tu pro vás.
          </p>
          <p className="body-large mb-8 max-w-2xl">
            Provádíme zednické práce při výstavbě a rekonstrukcích rodinných domů v Brně a okolí. 
            Realizujeme stavební projekty od menších úprav až po hrubé stavby rodinných domů.
          </p>
          <p className="body-medium mb-12 max-w-2xl" style={{ color: 'white', textShadow: '2px 2px 6px rgba(0, 0, 0, 0.8)' }}>
            Specializujeme se na hrubé stavby, stavební úpravy, fasády a zateplení a dbáme na kvalitní řemeslné 
            provedení každé zakázky. Pracujeme pečlivě, s důrazem na detail a férové jednání.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={scrollToContact}
              className="btn-primary text-lg px-8 py-6"
            >
              Nezávazná poptávka
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary text-lg px-8 py-6"
            >
              Naše služby
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
